import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Information from '../../../../../Shared/Card/Information';
import { GetAppInformationContent } from '../../../../../Shared/InformationContent/EFInformation';
import applicationService from '../../../../../../services/Public/Application/EF/efApplication.service';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../../../../Shared/GenericComponents/LoadingSpinner';
import { Form, Schema } from 'rsuite';
import FormActionButtons from '../../../../../Shared/FormAction/FormActionButtons';
import WavierCertificate from '../../../../../Shared/Card/WaiverCertificate';
import Issues from '../../../../../Shared/Card/Issues';

function WaiverCertificatePage() {
    const [hasLoaded, setHasLoaded] = useState(false);
    const [sectionData, setSectionData] = useState({});
    const routes = useSelector(x => x.currentRoutes);
    const sectionId = 13;
    const { StringType, BooleanType } = Schema.Types;
    const model = Schema.Model({
        hasWordOfferingProfessionalServices: BooleanType().isRequired('This field is required.'),
        electronicSignature: StringType().isRequired('This field is required.')
    });
    useEffect(() => {
        setHasLoaded(false);
        applicationService.efGetSection(store.currentApplicationId, sectionId).then((response) => {
            setSectionData(response.data);
            setHasLoaded(true);
        })


    }, [])
    const store = useSelector(x => x);

    const push = useNavigate();
    const showAdditionalFields = sectionData.hasWordOfferingProfessionalServices;

    const handleSubmit = (val, event) => {
        if (!sectionData.isUserEditable) {
            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
        }
        else {
            if (val) {
                applicationService.efPostSection(store.currentApplicationId, sectionId, sectionData.electronicSignature).then((response) => {
                    if (response.data) {
                        applicationService.efPostSectionHasWordOffering(store.currentApplicationId, sectionId, sectionData.hasWordOfferingProfessionalServices).then((data) => {
                            if (data.data)
                                push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
                        })
                    }
                })
            }

        }
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route);
    }
    return (
        <div>
            <Container fluid>
                <Form model={model} onSubmit={handleSubmit} onChange={setSectionData} fluid formValue={sectionData}>
                    <strong>Engineering Firm Application</strong>
                    <h4 className="mb-3">Waiver/Certificate</h4>
                    <Row className="mb-3">
                        <Col> <Information content={GetAppInformationContent("waiver")} /></Col>
                    </Row>
                    {hasLoaded ?
                        <>
                            <Row className="mb-3">
                                <Col>
                                    <WavierCertificate
                                        isApp={true}
                                        showAdditionalFields={showAdditionalFields}
                                        isReadOnly={!sectionData.isUserEditable}
                                        sectionId={sectionId}
                                        sectionDataId={sectionData.id}
                                        parentTypeId={1}
                                        credentialTypeId={1}
                                    />
                                </Col>
                            </Row>
                            <br />
                            <Issues isUserEditable={true} type={1} sectionId={sectionData.id} />
                            <FormActionButtons nextSectionCallback={nextSectionNavigation} isReadOnly={!sectionData.isUserEditable} backToSectionLink="/firm/efapp/sections" />
                        </> : <LoadingSpinner />
                    }
                </Form>
            </Container>
        </div>
    );
}
export default WaiverCertificatePage